import api from "./axios";

export const ProfileVisited = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/profiles-visited/", {
    params,
  });
  return response.data.data;
};

export const ProfileInterested = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/profiles-interested/", {
    params,
  });
  return response.data.data;
};

export const ProfileInterestedCount = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/profiles-interested-count/", {
    params,
  });
  return response.data.data;
};

export const ContactRequest = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/contact-requests/", {
    params,
  });
  return response.data.data;
};

export const Favorites = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/favorites/", {
    params,
  });
  return response.data.data;
};

export const ImageRequest = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/image-requests/", {
    params,
  });
  return response.data.data;
};

export const ImageRequestCount = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/image-requests-count/", {
    params,
  });
  return response.data.data;
};

export const removeFromProfile = async (payload) => {
  const response = await api.post(
    "/user_preference/remove-from-profile/",
    payload,
  );
  return response.data;
};
